import script from "./SelectorOptionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectorOptionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SelectorOptionHeader.vue?vue&type=style&index=0&id=644dba4e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644dba4e"]])

export default __exports__